"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Compare: function() {
        return Compare;
    },
    booleanComparer: function() {
        return booleanComparer;
    },
    combinedComparer: function() {
        return combinedComparer;
    },
    compare: function() {
        return compare;
    },
    compareDate: function() {
        return compareDate;
    },
    dateComparer: function() {
        return dateComparer;
    },
    getAnyComparer: function() {
        return getAnyComparer;
    },
    getArrayIndexComparer: function() {
        return getArrayIndexComparer;
    },
    getDateComparer: function() {
        return getDateComparer;
    },
    numberComparer: function() {
        return numberComparer;
    },
    propertyComparer: function() {
        return propertyComparer;
    },
    reverseComparer: function() {
        return reverseComparer;
    },
    stringComparer: function() {
        return stringComparer;
    },
    subValueComparer: function() {
        return subValueComparer;
    }
});
const _validation = require("./validation");
let Compare = class Compare {
    isLessThan(other) {
        return this.comparer(this.base, other) === -1;
    }
    isGreaterThan(other) {
        return this.comparer(this.base, other) === 1;
    }
    isEqual(other) {
        return this.comparer(this.base, other) === 0;
    }
    isNotEqual(other) {
        return this.comparer(this.base, other) !== 0;
    }
    isLessThanOrEqual(other) {
        return this.comparer(this.base, other) <= 0;
    }
    isGreaterThanOrEqual(other) {
        return this.comparer(this.base, other) >= 0;
    }
    constructor(base, comparer){
        this.base = base;
        this.comparer = comparer;
    }
};
function compare(base, comparer) {
    return new Compare(base, comparer);
}
function compareDate(date) {
    return new Compare(date, dateComparer);
}
function combinedComparer(...comparers) {
    return function(a, b) {
        for(let i = 0; i < comparers.length; i++){
            const result = comparers[i](a, b);
            if (result !== 0) {
                return result;
            }
        }
        return 0;
    };
}
function subValueComparer(getValue, comparer) {
    const innerComparer = comparer != null ? comparer : getAnyComparer();
    return function(a, b) {
        const aValue = getValue(a);
        const bValue = getValue(b);
        return innerComparer(aValue, bValue);
    };
}
function propertyComparer(key, comparer) {
    const innerComparer = comparer != null ? comparer : getAnyComparer();
    return function(a, b) {
        return innerComparer(a[key], b[key]);
    };
}
const numberComparer = valueComparer;
const booleanComparer = valueComparer;
const stringComparer = valueComparer;
const dateComparer = (a, b)=>{
    return valueComparer(a.valueOf(), b.valueOf());
};
function valueComparer(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function reverseComparer(comparer) {
    return (a, b)=>{
        return comparer(b, a);
    };
}
function getArrayIndexComparer(arr) {
    return (a, b)=>{
        return numberComparer(arr.indexOf(a), arr.indexOf(b));
    };
}
function getAnyComparer(objectComparer) {
    const finalObjectComparer = objectComparer != null ? objectComparer : (a, b)=>{
        if (a instanceof Date && b instanceof Date) {
            return dateComparer(a, b);
        }
        return -1;
    };
    return (a, b)=>{
        if (typeof a !== typeof b) {
            return -1;
        }
        const type = typeof a;
        switch(type){
            case 'bigint':
            case 'number':
            case 'boolean':
            case 'string':
                return valueComparer(a, b);
            case 'symbol':
            case 'function':
                return a === b ? 0 : -1;
            case 'undefined':
                return 0;
            case 'object':
                break;
            default:
                (0, _validation.assertNever)(type);
        }
        if (a === null && b === null) {
            return 0;
        }
        return finalObjectComparer(a, b);
    };
}
function getDateComparer(toleranceSeconds) {
    const toleranceMs = toleranceSeconds * 1000;
    return function(a, b) {
        const ms1 = a.valueOf();
        const ms2 = b.valueOf();
        if (ms1 < ms2 - toleranceMs) return -1;
        if (ms2 < ms1 - toleranceMs) return 1;
        return 0;
    };
}

//# sourceMappingURL=compare.js.map